// begin the map 
//import { epoly } from './api/epoly_apiv3-full';
//epoly();
import './components/app';
export { createMapKit, initMapKit, initGoogleMaps } from "./components/app";

